import React from "react";
import { Link } from "react-router-dom";

const CallToActionSection = ({
  title,
  description,
  primaryAction,
  secondaryAction,
}) => (
  <div className="bg-primary text-white text-center py-12">
    <h2 className="text-4xl font-bold">{title}</h2>
    {description && <p className="text-lg mt-4">{description}</p>}
    <div className="mt-8 flex justify-center gap-6">
      {primaryAction && (
        <Link
          to={primaryAction.link}
          className="bg-secondary text-white px-8 py-4 text-xl rounded-lg font-semibold hover:bg-secondary/80"
        >
          {primaryAction.text}
        </Link>
      )}
      {secondaryAction && (
        <Link
          to={secondaryAction.link}
          className="bg-white text-primary px-8 py-4 text-xl rounded-lg font-semibold hover:bg-white/70"
        >
          {secondaryAction.text}
        </Link>
      )}
    </div>
  </div>
);

export default CallToActionSection;
